import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74ec46c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-page" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "select" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Velg kunder:", -1))
const _hoisted_5 = { class: "clients" }
const _hoisted_6 = { class: "clients-table" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Navn"),
    /*#__PURE__*/_createElementVNode("th", { style: {"max-width":"100px","width":"100px"} }, "Handlinger")
  ])
], -1))
const _hoisted_8 = { class: "client" }
const _hoisted_9 = {
  key: 0,
  class: "empty-list"
}

import {ref, defineOptions} from "vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import Client from "@/types/Client";
import {useForm} from "@inertiajs/inertia-vue3";
import CustomerSelect from "@/Components/Forms/CustomerSelect.vue";
import Button from "@/Components/Buttons/Button.vue";
import {Inertia} from "@inertiajs/inertia";

export default /*#__PURE__*/_defineComponent({
  ...{
layout:AppLayout
},
  __name: 'MultipleOrders',
  props: {
    customers: {}
  },
  setup(__props: any) {

const props = __props;


const form = useForm({
  customers:[]
})


const submit = () => {
  form.post(route("customers.store_multiple_orders"), {
    preserveState:false,

    onSuccess: () =>{
    form.reset()
  }
  })
}
const remove = (customer:any) => {
  Inertia.post(route("customers.remove_multiple_orders", { client: customer }),{
  client:customer
  }, {
  preserveState:false,
  only:["customers"],
    onSuccess: () => {
    },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(CustomerSelect, {
          mode: "tags",
          modelValue: _unref(form).customers,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).customers) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(Button, {
        class: "submit-btn",
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode("Legg til")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (customer) => {
            return (_openBlock(), _createElementBlock("tr", _hoisted_8, [
              _createElementVNode("td", null, "#" + _toDisplayString(customer.id), 1),
              _createElementVNode("td", null, _toDisplayString(customer.firstname + " " + customer.lastname), 1),
              _createElementVNode("td", null, [
                _createVNode(Button, {
                  color: "red",
                  onClick: ($event: any) => (remove(customer.id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Fjern")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 256))
        ])
      ]),
      (_ctx.customers.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Listen er tom!"))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})